"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buttonVariants = exports.Button = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactSlot = require("@radix-ui/react-slot");
var _cn = require("@udecode/cn");
var _classVarianceAuthority = require("class-variance-authority");
var _jsxRuntime = require("react/jsx-runtime");
var buttonVariants = exports.buttonVariants = (0, _classVarianceAuthority.cva)('inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', {
  defaultVariants: {
    size: 'default',
    variant: 'default'
  },
  variants: {
    isMenu: {
      true: 'h-auto w-full cursor-pointer justify-start'
    },
    size: {
      default: 'h-10 px-4 py-2',
      icon: 'size-10',
      lg: 'h-11 rounded-md px-8',
      none: '',
      sm: 'h-9 rounded-md px-3',
      sms: 'size-9 rounded-md px-0',
      xs: 'h-8 rounded-md px-3'
    },
    variant: {
      default: 'bg-primary text-primary-foreground hover:bg-primary/90',
      destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
      ghost: 'hover:bg-accent hover:text-accent-foreground',
      inlineLink: 'text-base text-primary underline underline-offset-4',
      link: 'text-primary underline-offset-4 hover:underline',
      outline: 'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
      secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80'
    }
  }
});
var Button = exports.Button = (0, _cn.withRef)(function (_ref, ref) {
  var _ref$asChild = _ref.asChild,
    asChild = _ref$asChild === void 0 ? false : _ref$asChild,
    className = _ref.className,
    isMenu = _ref.isMenu,
    size = _ref.size,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, ["asChild", "className", "isMenu", "size", "variant"]);
  var Comp = asChild ? _reactSlot.Slot : 'button';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Comp, _objectSpread({
    className: (0, _cn.cn)(buttonVariants({
      className: className,
      isMenu: isMenu,
      size: size,
      variant: variant
    })),
    ref: ref
  }, props));
});